// Due current implementation of filters that is not compatible with constructor.io filtering this function
// is needed to convert string from filters to object with list of values needed for constructor.io filtering

import { parseFilterString } from '~/modules/PLP/lib/parseFilterString'

/* 
queryFilters - filters that are saved in router
*/
export const mapQueryToFilters = (queryFilters: string) => {
  let filters: Record<string, string[]> = parseFilterString(queryFilters)
  for (const element in filters) {
    const filter = filters[element]
    // removing id separator that makes value unique
    filters[element] = filter.map((element) => element.split('id')[0])
  }

  return filters
}
